import { Select } from '@mantine/core';

import { useMessageCategories } from '../endpoints';
import { MessageCategoryConfig } from '../model';
import { useMessageEditorFormContext } from './context.ts';

const fromMessageCategoriesToOptions = (
  data: MessageCategoryConfig[],
): Array<{ value: string; label: string }> => {
  return data.map(({ name, key }) => ({ value: String(key), label: name }));
};

export const SelectCategory = () => {
  const form = useMessageEditorFormContext();
  const { data: messageCategories = [], isLoading } = useMessageCategories();

  const options = fromMessageCategoriesToOptions(messageCategories);

  return (
    <Select
      label="訊息分類"
      withAsterisk
      loading={isLoading}
      placeholder="請選擇訊息分類"
      allowDeselect={false}
      data={options}
      key={form.key('messageCategoryKey')}
      {...form.getInputProps('messageCategoryKey')}
    />
  );
};
